import React from "react";

const CategoryCta = (props) => {
  const { category, isActive, setActiveCategory, setAreCategoriesOpen } = props;
  return (
    <div
      className={`virtual-events-category-cta ${
        isActive ? "isActive" : "isInactive"
      }`}
      onClick={() => {
        setActiveCategory(category);
        setAreCategoriesOpen(false);
      }}
    >
      <span className="virtual-events-category-cta__dot"></span>
      <span className="virtual-events-category-cta__name p">
        {category.name}
      </span>
    </div>
  );
};

export default CategoryCta;
